import React, { useContext, useEffect, useState } from "react";
import { Box, Button, Paper, TextField, Typography, MenuItem, CircularProgress } from "@mui/material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { AddWebsitePublicLeadsApi } from "../../Api/PublicLeadsApi/AddPublicLeadsApi";
import { SnackBarContext } from "../../Context/SnackBarContext/SnackBarContext";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchWebsitePublicLeadPopulate,
  getFacebookPageDetails,
} from "../../Redux/Slice/Settings/FacebookPageSlice/FacebookPageSlice";
import * as Yup from "yup";
import { useFormik } from "formik";

function PublicForm() {
  const { setsnackBarData } = useContext(SnackBarContext);
  const dispatch = useDispatch();
  const { WebsitePublicForm, status } = useSelector(getFacebookPageDetails);
  const [businessId, setBusinessId] = useState(null);
  const [uiData, setUiData] = useState({
    btnColor: "",
    btnText: "",
    btnTextColor: "",
    inputRadius: "",
    inputBg: "",
    labelColor: "",
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setBusinessId(params.get("businessId"));
    setUiData({
      // btnColor: params.get("btnColor") || "#298B8B",
      // btnTextColor: params.get("btnTextColor") || "#fff",
      btnText: params.get("btnText") || "Submit",
      inputRadius: params.get("inputRadius") || "4px",

      inputBg: params.get("inputBg") || "#f5f7fa",
      labelColor: params.get("labelColor") || "#616161",
    });
  }, []);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (businessId) {
      dispatch(fetchWebsitePublicLeadPopulate(businessId));
    }
  }, [businessId, dispatch]);

  const validationSchema = Yup.object({
    customerName: Yup.string().required("Customer name is required"),
    // phone: Yup.string().required("Phone number is required"),
    email: Yup.string().email("Invalid email"),
    // projectId: Yup.string().required("Project is required"),
    // categoryId: Yup.string().required("Category is required"),
    phone: Yup.string()
      .required("Phone number is required")
      .test("valid-phone", "Please enter phone number", function (value) {
        const { dialCode } = this.parent;
        if (!value || !dialCode) return false;

        return value.length > dialCode.length;
      }),
  });

  const formik = useFormik({
    initialValues: {
      customerName: "",
      phone: "",
      dialCode: "",
      email: "",
      projectId: "",
      categoryId: "",
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      const phoneWithoutDialCode = values.phone.startsWith(values.dialCode)
        ? values.phone.slice(values.dialCode.length)
        : values.phone;

      const payload = {
        customerName: values.customerName,
        phoneNumber: phoneWithoutDialCode,
        dialCode: values.dialCode,
        email: values.email,
        projectId: values.projectId,
        categoryId: values.categoryId,
      };

      try {
        const response = await AddWebsitePublicLeadsApi(payload, businessId);

        if (response?.data?.IsSuccess) {
          resetForm();
        }
        setsnackBarData(response.snackBarData);
      } catch (error) {
        setsnackBarData({
          type: "error",
          message: "Failed to submit inquiry",
          openToast: true,
        });
      } finally {
        setLoading(false);
      }
    },
  });

  if (status === "loading") {
    return (
      <Paper
        elevation={3}
        sx={{
          bgcolor: "#ffffff00",
          boxShadow: "none",
          p: 3,
          textAlign: "center",
          height: "350px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box>
          <CircularProgress />
          <Typography variant="h6">Loading...</Typography>
        </Box>
      </Paper>
    );
  }

  return (
    <Paper elevation={3} sx={{ maxWidth: "450px", mx: "auto", p: 4, borderRadius: 2, boxShadow: "none" }}>
      <Box component="form" onSubmit={formik.handleSubmit} display="flex" flexDirection="column" gap={2}>
        <TextField
          label="Name*"
          name="customerName"
          value={formik.values.customerName}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.customerName && Boolean(formik.errors.customerName)}
          // helperText={formik.touched.customerName && formik.errors.customerName}
          fullWidth
          size="small"
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: uiData.inputRadius,
              backgroundColor: uiData.inputBg,
            },
            "& label": {
              color: uiData.labelColor,
            },
          }}
        />

        <PhoneInput
          country={"pk"}
          value={formik.values.phone}
          onChange={(value, data) => {
            formik.setFieldValue("phone", value);
            formik.setFieldValue("dialCode", data.dialCode);
          }}
          inputProps={{ name: "phone" }}
          inputStyle={{
            width: "100%",
            height: "40px",
            borderColor: formik.touched.phone && formik.errors.phone ? "red" : "#ccc",
          }}
          containerStyle={{ width: "100%" }}
        />
        {/* {formik.touched.phone && formik.errors.phone && (
          <Typography color="error" fontSize="12px">
            {formik.errors.phone}
          </Typography>
        )} */}

        <TextField
          label="Email"
          name="email"
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.email && Boolean(formik.errors.email)}
          // helperText={formik.touched.email && formik.errors.email}
          fullWidth
          size="small"
        />

        <TextField
          select
          label="Project"
          name="projectId"
          value={formik.values.projectId}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.projectId && Boolean(formik.errors.projectId)}
          // helperText={formik.touched.projectId && formik.errors.projectId}
          fullWidth
          size="small"
        >
          <MenuItem value="">Select Project</MenuItem>
          {WebsitePublicForm?.Projects?.map(project => (
            <MenuItem key={project.ProjectId} value={project.ProjectId}>
              {project.ProjectName}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          select
          label="Category"
          name="categoryId"
          value={formik.values.categoryId}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.categoryId && Boolean(formik.errors.categoryId)}
          // helperText={formik.touched.categoryId && formik.errors.categoryId}
          fullWidth
          size="small"
        >
          <MenuItem value="">Select Category</MenuItem>
          {WebsitePublicForm?.Categories?.map(category => (
            <MenuItem key={category.CategoryId} value={category.CategoryId}>
              {category.CategoryName}
            </MenuItem>
          ))}
        </TextField>

        <Button
          variant="contained"
          type="submit"
          disabled={loading}
          sx={{ mt: 1, py: 1.2 }}
          // sx={{
          //   mt: 1,
          //   py: 1.2,
          //   backgroundColor: uiData?.btnColor,
          //   color: uiData?.btnTextColor,
          //   boxShadow: "none",
          //   "&:hover": {
          //     backgroundColor: uiData?.btnColor,
          //   },
          //   "&.Mui-disabled": {
          //     backgroundColor: uiData?.btnColor,
          //     color: uiData?.btnTextColor,
          //     opacity: 0.7,
          //   },
          // }}
        >
          {loading ? "Submitting..." : uiData?.btnText}
        </Button>
      </Box>
    </Paper>
  );
}

export default PublicForm;

{
  /* <div className="container">
          <div className="row" style={{ margin: "50px 0px" }}>
            <div
              className="col-lg-6"
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <h2
                style={{
                  fontWeight: "700",
                  color: "#333",
                  marginBottom: "20px",
                }}
              >
                Contact Our Team
              </h2>
              <p
                style={{
                  fontSize: "16px",
                  color: "#555",
                }}
              >
                Fill out this quick form. Select the project and category that
                matches your needs and our team will reach out to provide
                detailed information and guide you through the next steps.
              </p>
            </div>
            <div className="col-lg-6">
              <iframe
                src={`http://localhost:3001/public-form?businessId=45b2acb8-b7ee-41a7-bbcf-bbdb98455cdc&btnText=Submit&inputRadius=4px&inputBg=%23FFFFFF&labelColor=%23616161`}
                width="100%"
                height={390}
                style={{
                  border: "none",
                  borderRadius: "8px",
                  overflow: "hidden",
                }}
              ></iframe>
            </div>
          </div>
        </div> */
}

// import React, { useContext, useEffect, useState } from "react";
// import { Box, Button, Paper, TextField, Typography, FormControl, MenuItem, CircularProgress } from "@mui/material";
// import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/style.css";
// import { AddWebsitePublicLeadsApi } from "../../Api/PublicLeadsApi/AddPublicLeadsApi";
// import { SnackBarContext } from "../../Context/SnackBarContext/SnackBarContext";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   fetchWebsitePublicLeadPopulate,
//   getFacebookPageDetails,
// } from "../../Redux/Slice/Settings/FacebookPageSlice/FacebookPageSlice";

// function PublicForm() {
//   const { setsnackBarData } = useContext(SnackBarContext);
//   const dispatch = useDispatch();
//   const { WebsitePublicForm, status } = useSelector(getFacebookPageDetails);

//   const [formData, setFormData] = useState({
//     customerName: "",
//     email: "",
//     projectId: "",
//     categoryId: "",
//   });

//   const [businessId, setBusinessId] = useState(null);
//   const [uiData, setUiData] = useState({
//     btnColor: "",
//     btnText: "",
//     btnTextColor: "",
//     inputRadius: "",
//     inputBg: "",
//     labelColor: "",
//   });

//   useEffect(() => {
//     const params = new URLSearchParams(window.location.search);
//     setBusinessId(params.get("businessId"));
//     setUiData({
//       // btnColor: params.get("btnColor") || "#298B8B",
//       // btnTextColor: params.get("btnTextColor") || "#fff",
//       btnText: params.get("btnText") || "Submit",
//       inputRadius: params.get("inputRadius") || "4px",

//       inputBg: params.get("inputBg") || "#f5f7fa",
//       labelColor: params.get("labelColor") || "#616161",
//     });
//   }, []);

//   const [phone, setPhone] = useState("");
//   const [dialCode, setDialCode] = useState("");
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     if (businessId) {
//       dispatch(fetchWebsitePublicLeadPopulate(businessId));
//     }
//   }, [businessId, dispatch]);

//   const handleChange = e => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleMobile = (value, data) => {
//     setPhone(value);
//     setDialCode(data.dialCode);
//   };

//   const handleSubmit = async e => {
//     e.preventDefault();
//     setLoading(true);

//     const phoneWithoutDialCode = phone.startsWith(dialCode) ? phone.slice(dialCode.length) : phone;

//     const payload = {
//       customerName: formData.customerName,
//       phoneNumber: phoneWithoutDialCode,
//       dialCode: dialCode,
//       email: formData.email,
//       projectId: formData.projectId,
//       categoryId: formData.categoryId,
//     };

//     try {
//       const response = await AddWebsitePublicLeadsApi(payload, businessId);
//       setsnackBarData(response.snackBarData);

//       if (response?.data?.IsSuccess) {
//         // setSuccess(true);
//       }
//     } catch (error) {
//       setsnackBarData({
//         type: "error",
//         message: "Failed to submit inquiry",
//         openToast: true,
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (status === "loading") {
//     return (
//       <Paper
//         elevation={3}
//         sx={{
//           bgcolor: "#ffffff00",
//           boxShadow: "none",
//           p: 3,
//           textAlign: "center",
//           height: "350px",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         <Box>
//           <CircularProgress />
//           <Typography variant="h6">Loading...</Typography>
//         </Box>
//       </Paper>
//     );
//   }

//   return (
//     <Paper elevation={3} sx={{ maxWidth: "450px", mx: "auto", p: 4, borderRadius: 2, boxShadow: "none" }}>
//       <Box component="form" onSubmit={handleSubmit} display="flex" flexDirection="column" gap={2}>
//         <TextField
//           label="Customer Name"
//           name="customerName"
//           value={formData.customerName}
//           onChange={handleChange}
//           // required
//           fullWidth
//           size="small"
//           sx={{
//             "& .MuiOutlinedInput-root": {
//               borderRadius: uiData.inputRadius,
//               backgroundColor: uiData.inputBg,
//             },
//             "& label": {
//               color: uiData.labelColor,
//             },
//           }}
//         />

//         <FormControl fullWidth>
//           <PhoneInput
//             country={"pk"}
//             value={phone}
//             onChange={handleMobile}
//             sx={{
//               "& .MuiOutlinedInput-root": {
//                 borderRadius: uiData.inputRadius,
//                 backgroundColor: uiData.inputBg,
//               },
//               "& label": {
//                 color: uiData.labelColor,
//               },
//             }}
//             inputStyle={{
//               width: "100%",
//               height: "40px",
//             }}
//             containerStyle={{ width: "100%" }}
//           />
//         </FormControl>

//         <TextField
//           label="Email"
//           name="email"
//           type="email"
//           value={formData.email}
//           onChange={handleChange}
//           fullWidth
//           size="small"
//           sx={{
//             "& .MuiOutlinedInput-root": {
//               borderRadius: uiData.inputRadius,
//               backgroundColor: uiData.inputBg,
//             },
//             "& label": {
//               color: uiData.labelColor,
//             },
//           }}
//         />

//         <TextField
//           select
//           label="Project"
//           name="projectId"
//           value={formData.projectId}
//           onChange={handleChange}
//           // required
//           fullWidth
//           size="small"
//           sx={{
//             "& .MuiOutlinedInput-root": {
//               borderRadius: uiData.inputRadius,
//               backgroundColor: uiData.inputBg,
//             },
//             "& label": {
//               color: uiData.labelColor,
//             },
//           }}
//         >
//           <MenuItem value="">Select Project</MenuItem>
//           {WebsitePublicForm?.Projects?.map(project => (
//             <MenuItem key={project.ProjectId} value={project.ProjectId}>
//               {project.ProjectName}
//             </MenuItem>
//           ))}
//         </TextField>

//         <TextField
//           select
//           label="Category"
//           name="categoryId"
//           value={formData.categoryId}
//           onChange={handleChange}
//           // required
//           fullWidth
//           size="small"
//           sx={{
//             "& .MuiOutlinedInput-root": {
//               borderRadius: uiData.inputRadius,
//               backgroundColor: uiData.inputBg,
//             },
//             "& label": {
//               color: uiData.labelColor,
//             },
//           }}
//         >
//           <MenuItem value="">Select Category</MenuItem>
//           {WebsitePublicForm?.Categories?.map(category => (
//             <MenuItem key={category.CategoryId} value={category.CategoryId}>
//               {category.CategoryName}
//             </MenuItem>
//           ))}
//         </TextField>

//         <Button
//           variant="contained"
//           type="submit"
//           disabled={loading}
//           sx={{ mt: 1, py: 1.2 }}
//           // sx={{
//           //   mt: 1,
//           //   py: 1.2,
//           //   backgroundColor: uiData?.btnColor,
//           //   color: uiData?.btnTextColor,
//           //   boxShadow: "none",
//           //   "&:hover": {
//           //     backgroundColor: uiData?.btnColor,
//           //   },
//           //   "&.Mui-disabled": {
//           //     backgroundColor: uiData?.btnColor,
//           //     color: uiData?.btnTextColor,
//           //     opacity: 0.7,
//           //   },
//           // }}
//         >
//           {loading ? "Submitting..." : uiData?.btnText}
//         </Button>
//       </Box>
//     </Paper>
//   );
// }

// export default PublicForm;
